<template lang="html">

<ul class="slds-accordion">
  <li class="slds-accordion__list-item" v-for="entry in entries" v-bind:key="entry.id" >
    <section class="slds-accordion__section" v-bind:class="{'slds-is-open':entry.open}">
      <div class="slds-accordion__summary">
        <h2 class="slds-accordion__summary-heading">
          <button class="slds-button slds-button_reset slds-accordion__summary-action" aria-controls="referenceId-45" aria-expanded="true" title="Accordion summary" v-on:click="entry.open=!entry.open">
            <svg class="slds-accordion__summary-action-icon slds-button__icon slds-button__icon_left" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#switch"></use>
            </svg>
            <span class="slds-accordion__summary-content">{{entry.label}}</span>
          </button>
        </h2>
      </div>
      <div class="slds-accordion__content" id="referenceId-45">
        <slot v-bind:name="entry.name">
        </slot>
      </div>
    </section>
  </li>
</ul>

</template>

<script>
export default {
  name: 'accordion',
  components: {

  },
  props: {
    entries: Array,
  },
  data() {
    return {
      opened:false
    }
  },
  computed: {

  },
  mounted: function() {
  },
  async created() {

  },
  methods: {
    clickTab: function(index) {
      this.$emit('click', index);
    },
  }
}
</script>

<style scoped>

</style>
